/* @flow */
import type { UserProfile } from 'users/components/UsersProfile';
import type { UserActionsMenuButtonUser } from 'user/components/UserActionsMenuButton';

export default function mapGraphQLMemberToUserActionsMenuButtonUser(
  member: UserProfile
): UserActionsMenuButtonUser {
  const { firstName, lastName, roles, potentialRoles, userInteractionPermissions } = member;

  const {
    canChangeRole,
    canGetMessageHistory,
    canRequestMessageHistory,
    canAddAsGroupOwner,
    canRemoveFromGroup,
  } = userInteractionPermissions;

  return {
    // TODO: maybe just 'name' should be enough, and dependencies should change?
    first_name: firstName || '',
    last_name: lastName || '',

    can_become_owner: canAddAsGroupOwner,
    can_remove_from_group: canRemoveFromGroup,

    roles: [...roles],
    potential_roles: [...(potentialRoles || [])],
    can_have_role_changed: canChangeRole,

    can_get_message_history: canGetMessageHistory,
    can_request_message_history: canRequestMessageHistory,

    // TODO: how to get these?
    blocked: false,
    can_admin: false,

    // These are only for RelationshipView, which isn't enabled in this context
    is_owner: false,
    can_remove_from_org: false,

    ...member,
  };
}
